import React from "react"

import LocationFilter from './sections/LocationFilter'
import AgeFilter from './sections/AgeFilter'
import GenderFilter from './sections/GenderFilter'
import LanguageFilter from './sections/LanguageFilter'
import StandardModal from '../app_components/StandardModal'

class MatchFiltersContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      min_age_difference: 18,
      max_age_difference: 152,
      gender_id: 1,
      language_ids: [],
      needLanguageModal: false,
    }

    this.updateGender = this.updateGender.bind(this)
    this.updateAge = this.updateAge.bind(this)
    this.updateLanguageIds = this.updateLanguageIds.bind(this)
    this.updateLocation = this.updateLocation.bind(this)
  }

  componentDidMount() {
    this.setState({
      min_age_difference: this.props.filters.min_age_difference,
      max_age_difference: this.props.filters.max_age_difference,
      gender_id: this.props.filters.gender_id,
      language_ids: this.props.filters.language_ids,
    })
  }

  updateLanguageIds(language_id) {
    let language_ids = [...this.state.language_ids]

    if (language_ids.includes(language_id)) {
      if (language_ids.length === 1) {
        this.setState({ needLanguageModal: true })
      } else {
        language_ids = language_ids.filter((id) => id !== language_id)
      }
    } else {
      language_ids.push(language_id)
    }

    this.setState({ language_ids }, () => {
      this.props.updateFilter('language_ids', this.state.language_ids)
    })
  }

  updateGender(gender_id) {
    this.setState({ gender_id })
    this.props.updateFilter('gender_id', gender_id)
  }

  updateAge(min_age, max_age) {
    this.setState({
      min_age_difference: min_age,
      max_age_difference: max_age,
    })
    this.props.updateFilter('min_age_difference', min_age)
    this.props.updateFilter('max_age_difference', max_age)
  }

  updateLocation(value) {
    this.props.updateFilter('locals_only', value)
  }

  render() {
    return (
      <div className="matchFiltersModal__panel">
        {this.state.needLanguageModal && (
          <StandardModal onClose={() => this.setState({ needLanguageModal: false })}>
            <h3 className="matchFiltersModal__alertTitle">Keep at least one language</h3>
            <p className="matchFiltersModal__alertText">
              Select at least one language you want your matches to speak natively.
            </p>
          </StandardModal>
        )}

        <LanguageFilter
          current_user={this.props.current_user}
          languages_users={this.props.languages_users}
          filters={this.props.filters}
          updateLanguageIds={this.updateLanguageIds}
          learningLanguages={this.props.learningLanguages}
          nativeLanguages={this.props.nativeLanguages}
        />

        <GenderFilter
          selectedGender={this.state.gender_id}
          userGender={this.props.current_user.gender_id}
          toggleProModal={this.props.toggleProModal}
          premiumUser={this.props.premiumUser}
          updateGender={this.updateGender}
        />

        <AgeFilter
          current_user={this.props.current_user}
          min_age_difference={this.state.min_age_difference}
          max_age_difference={this.state.max_age_difference}
          updateAge={this.updateAge}
          premiumUser={this.props.premiumUser}
          toggleProModal={this.props.toggleProModal}
        />

        <LocationFilter
          updateLocation={this.updateLocation}
          locals_only={this.props.filters.locals_only}
          filter={true}
        />
      </div>
    )
  }
}

export default MatchFiltersContainer
